import React from 'react';
import { VariableHide } from '@grafana/data';
import { SceneObjectBase } from '../../core/SceneObjectBase.js';
import { sceneGraph } from '../../core/sceneGraph/index.js';
import { ControlsLabel } from '../../utils/ControlsLabel.js';
import { css } from '@emotion/css';

class VariableValueSelectors extends SceneObjectBase {
}
VariableValueSelectors.Component = VariableValueSelectorsRenderer;
function VariableValueSelectorsRenderer({ model }) {
  const variables = sceneGraph.getVariables(model).useState();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, variables.variables.map((variable) => /* @__PURE__ */ React.createElement(VariableValueSelectWrapper, {
    key: variable.state.key,
    variable,
    layout: model.state.layout
  })));
}
function VariableValueSelectWrapper({ variable, layout }) {
  const state = variable.useState();
  if (state.hide === VariableHide.hideVariable) {
    return null;
  }
  if (layout === "vertical") {
    return /* @__PURE__ */ React.createElement("div", {
      className: verticalContainer
    }, /* @__PURE__ */ React.createElement(VariableLabel, {
      variable,
      layout
    }), /* @__PURE__ */ React.createElement(variable.Component, {
      model: variable
    }));
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: containerStyle
  }, /* @__PURE__ */ React.createElement(VariableLabel, {
    variable
  }), /* @__PURE__ */ React.createElement(variable.Component, {
    model: variable
  }));
}
function VariableLabel({ variable, layout }) {
  var _a, _b;
  const { state } = variable;
  if (variable.state.hide === VariableHide.hideLabel) {
    return null;
  }
  const elementId = `var-${state.key}`;
  const labelOrName = (_a = state.label) != null ? _a : state.name;
  return /* @__PURE__ */ React.createElement(ControlsLabel, {
    htmlFor: elementId,
    isLoading: state.loading,
    onCancel: () => {
      var _a2;
      return (_a2 = variable.onCancel) == null ? void 0 : _a2.call(variable);
    },
    label: labelOrName,
    error: state.error,
    layout,
    description: (_b = state.description) != null ? _b : void 0
  });
}
const containerStyle = css({ display: "flex" });
const verticalContainer = css({ display: "flex", flexDirection: "column" });

export { VariableValueSelectors };
//# sourceMappingURL=VariableValueSelectors.js.map
